import type { layout } from "@app/domain";

/** Seats drawn relative to you: yours at the bottom; play goes to the right (seat+1 on your right). */
export function seatSlots(
  yourSeat: number | null,
): Record<layout.ElementId & `seat${string}`, number> {
  const me = yourSeat ?? 0;
  return {
    seatSelf: me,
    seatRight: (me + 1) % 4,
    seatTop: (me + 2) % 4,
    seatLeft: (me + 3) % 4,
  };
}
